import HotelCardLocation from './HotelCardLocation';

export default HotelCardLocation;
